import React from 'react'
import ColorPickerPopupForCalendar from '../ColorPickerPopupForCalendar/ColorPickerPopupForCalendar'
import { ChevronUpIcon } from '@heroicons/react/20/solid'
import axios from 'axios'
import { truncate } from '../calendarFunctions'
import { baseUrl } from '../../assets/Animations'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const TeacherListForCalendar = ({teachersToDisplayObject, setTeachersToDisplayObject, loadingTeachers, setLoadingTeachers, unselectAllTeachers}) => {
    const [openColorPicker, setOpenColorPicker] = React.useState(false)
    const [toggleTeacherList, setToggleTeacherList] = React.useState(false)
    const [areTeachersSelected, setAreTeachersSelected] = React.useState(false)
    const [hideTeachersWhoLeft, setHideTeachersWhoLeft] = React.useState(true)

    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

    React.useEffect(() => {
      toggleTeacherList ? document.getElementById('calendar__custom-left-column__teacher-list').style.height = '0px' : document.getElementById('calendar__custom-left-column__teacher-list').style.height = '80%'
      toggleTeacherList ? document.getElementById('calendar__custom-left-column__teacher-list').style.maxHeight = '0px' : document.getElementById('calendar__custom-left-column__teacher-list').style.maxHeight = '900px'
    }, [toggleTeacherList])

    React.useEffect(() => {
      checkIfAnyTeachersSelected()
    }, [teachersToDisplayObject])

    const checkIfAnyTeachersSelected = () => {
      let obj = teachersToDisplayObject
      let selected = false
      Object.keys(obj).map((teach) => {
        if(obj[teach].displayed) {
          selected = true
        }
        setAreTeachersSelected(selected)
      })
    }

    const showColorPicker = (id) => {
        document.getElementById(`teacher-calendar-${id}`).style.opacity = 1
      }
      const hideColorPicker = (id) => {
        document.getElementById(`teacher-calendar-${id}`).style.opacity = 0
      }
      const toggleTeacher = (teach) => {
        if(teach === 'toggle-all-off') {
          unselectAllTeachers()
        } else if (teach === 'toggle-all-on') {
          let obj = teachersToDisplayObject
          Object.keys(obj).map((teach) => {
            obj[teach].displayed = true
            setTeachersToDisplayObject({...obj})
          })
        } else {
          let obj = teachersToDisplayObject
          obj[teach].displayed = !teachersToDisplayObject[teach].displayed
          setTeachersToDisplayObject({...obj})
        }
      }

      const toggleOldTeachers = (value) => {
        if(value) {
          //set all teachers with the status 'Left School' to displayed: false
          let obj = teachersToDisplayObject
          Object.keys(obj).map((teach) => {
            if(obj[teach].Status === 'Left School') {
              obj[teach].ShowTeacherInList = true
            }
            setTeachersToDisplayObject({...obj})
          })
          setHideTeachersWhoLeft(false)
        } else {
          //set all teachers with the status 'Left School' to displayed: true
          let obj = teachersToDisplayObject
          Object.keys(obj).map((teach) => {
            if(obj[teach].Status === 'Left School') {
              obj[teach].ShowTeacherInList = false
            }
            setTeachersToDisplayObject({...obj})
          })
          setHideTeachersWhoLeft(true)
        }


      }
    
      const changeTeacherColor = (teach, color) => {
        axios.put(`${baseUrl}/changecalendarcolor/${teachersToDisplayObject[teach].TeacherID}`,
        { CalendarColor: color }, myHeader)
        .then((res) => {
          teachersToDisplayObject[teach].color = res.data.CalendarColor
          setTeachersToDisplayObject({...teachersToDisplayObject})
          setOpenColorPicker(false)
        })
        .catch((err) => {
    
        })
      }

    return(
      <div className='calendar__custom-left-column'>
        <div className='text-left mt-24 cursor-pointer hover:bg-gray-50'>
          <div className='ml-20 inline-block font-extrabold text-gray-700 overflow-hidden' onClick={() => setToggleTeacherList(!toggleTeacherList)}>Teachers</div>
          <ChevronUpIcon className={classNames(toggleTeacherList && 'rotate-180', "h-6 w-6 inline-block transition-rotate duration-300 ml-16 mt-1")} aria-hidden="true" />
        </div>
          <div className='calendar__custom-left-column__teacher-list' id="calendar__custom-left-column__teacher-list">
          {loadingTeachers && <div className='calendar__custom-left-column__teacher-list__loading'>Getting Teachers...</div>}
          <div key="turn-off" className="text-left py-0 h-auto align-middle hover:bg-gray-100 cursor-pointer">
              <div onClick={() => toggleTeacher(areTeachersSelected ? 'toggle-all-off' : 'toggle-all-on')} className={classNames(`w-4 h-4 ml-20 inline-block align-middle rounded-sm border-solid border-2`)}></div>
              <div className="p-0 inline-block ml-2 text-xs font-semibold align-middle my-1.5 text-gray-700 tracking-wide">{areTeachersSelected ? 'Unselect All' : 'Select All'}</div>
            </div>
            <div key="turn-on" className="text-left py-0 h-auto align-middle hover:bg-gray-100 cursor-pointer">
              <div onClick={() => toggleOldTeachers(hideTeachersWhoLeft)} className={classNames(`w-4 h-4 ml-20 inline-block align-middle rounded-sm border-solid border-2`)}></div>
              <div className="p-0 inline-block ml-2 text-xs font-semibold align-middle my-1.5 text-gray-700 tracking-wide">{hideTeachersWhoLeft ? 'Show Ex-Teachers' : 'Hide Ex-Teachers'}</div>
            </div>
          {Object.keys(teachersToDisplayObject).map((teach) => (
            teachersToDisplayObject[teach].ShowTeacherInList && 
            <div key={teachersToDisplayObject[teach].TeacherID} onMouseEnter={() => showColorPicker(teachersToDisplayObject[teach].TeacherID)} onMouseLeave={() => hideColorPicker(teachersToDisplayObject[teach].TeacherID)} className="text-left py-0 h-auto align-middle hover:bg-gray-100 cursor-pointer">
              {openColorPicker === teachersToDisplayObject[teach].TeacherID && <ColorPickerPopupForCalendar changeTeacherColor={changeTeacherColor} teach={teach} teachObj={teachersToDisplayObject[teach]} setOpenColorPicker={setOpenColorPicker} />}
              <div onClick={() => toggleTeacher(teach)} className={classNames(teachersToDisplayObject[teach].displayed ? `${teachersToDisplayObject[teach].color.bgColor500 ? teachersToDisplayObject[teach].color.bgColor500 : 'bg-gray-300'}` : `bg-white`, `w-4 h-4 ml-20 inline-block align-middle rounded-sm border-solid border-2 ${teachersToDisplayObject[teach].color.borderColor500}`)}></div>
              <div className={`p-0 inline-block ml-2 text-xs font-semibold align-middle my-1.5 text-gray-700 tracking-wider ${teachersToDisplayObject[teach].Status === 'Left School' && 'line-through'}`}>{truncate(teach, 15)}</div>
              <div id={`teacher-calendar-${teachersToDisplayObject[teach].TeacherID}`} onClick={() => setOpenColorPicker(teachersToDisplayObject[teach].TeacherID)} className='inline-block relative float-right opacity-0 right-3 m-0 w-4 h-4 mt-0.5 text-right'><svg width="60%" height="100%" viewBox="-5 5 100 100"><path fill="gray" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z"/></svg></div>
            </div>
          ))}
        </div>
      </div>
    )
}
export default TeacherListForCalendar